import { NotificationsDropdownMenu } from '@/app-shell/layout/Navigation/notifications/notifications-dropdown-menu';

/**
 * Notifications dropdown menu action for the mobile panel header.
 * Reuses the same kebab menu used in the desktop popover header.
 */
export function NotificationsPanelAction() {
  return <NotificationsDropdownMenu />;
}
